'use client'

import React from 'react'
import styled from 'styled-components'

import {
  Button,
  ResponsiveImageWithSkeletonWrapper,
  TextLink,
  TypeStyleBodyMedium,
  TypeStyleBodyMicro,
  TypeStyleBodyNano,
  TypeStyleBodySmall,
  fromMd,
  untilMd,
} from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../_providers/TranslationProvider.client'

export const MaxWidthContainer = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(5)};
  align-items: center;
`

export const TermsAcceptance = ({ text }: { text?: string }) => {
  const {
    magnolia: { general },
  } = useTranslation()

  text = text || general.termsAcceptance
  const parts = text.split(
    /(\{\{termsOfUse\}\}|\{\{privacyPolicy\}\}|\{\{teamsOrderSupplementalTerms\}\})/
  )

  return (
    <TermsTypography>
      {parts.map((part, i) => {
        if (part === '{{termsOfUse}}') {
          return (
            <TextLink key={i} inheritTypography href='/pages/terms-of-use'>
              {general.termsOfUse}
            </TextLink>
          )
        }
        if (part === '{{privacyPolicy}}') {
          return (
            <TextLink key={i} inheritTypography href='/pages/privacy'>
              {general.privacyPolicy}
            </TextLink>
          )
        }
        if (part === '{{teamsOrderSupplementalTerms}}') {
          return (
            <TextLink key={i} inheritTypography href='/pages/supplemental-terms'>
              {general.teamsOrderSupplementalTerms}
            </TextLink>
          )
        }
        return part
      })}
    </TermsTypography>
  )
}

export const FormLabelTypography = styled(TypeStyleBodyNano).attrs({ asTag: 'label' })`
  font-weight: 700;
`

export const AccountSignupTypography = styled(TypeStyleBodySmall)`
  font-weight: 700;
  width: 100%;
`

export const GrayHorizontalBar = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  width: 100%;
`

export const GreenMessage = styled(TypeStyleBodyMedium)`
  padding: ${o => o.theme.spacing(4)};
  background: ${o => o.theme.color.fill.celebratory.subtle};
  color: ${o => o.theme.color.stroke.celebratory.text.on.subtle};
  border-left: 4px solid ${o => o.theme.color.stroke.celebratory.text.on.subtle};
  font-weight: 400;
`

export const ErrorToastMessage = styled(TypeStyleBodyMedium)`
  padding: ${o => o.theme.spacing(4)};
  background: ${o => o.theme.color.fill.critical.subtle};
  color: ${o => o.theme.color.stroke.critical.text.on.subtle};
  border-left: 4px solid ${o => o.theme.color.stroke.critical.text.on.subtle};
  font-weight: 400;
`

export const CancelButton = styled(Button)`
  width: 100%;
  text-underline-offset: 4px;
  text-decoration: underline;
  height: 64px;
  box-sizing: border-box;
`

export const FormInputComponents = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(2)};
`

export const Error = styled(TypeStyleBodyMicro)`
  color: ${o => o.theme.color.text.critical.on.background};
`

const TermsTypography = styled(TypeStyleBodyMicro)`
  text-align: center;
  padding: ${o => o.theme.spacing(0, 4)};
`

export const LoginImage = styled(ResponsiveImageWithSkeletonWrapper)`
  ${untilMd} {
    display: none;
  }
`

export const RegisterButton = styled(Button)`
  width: 100%;
  padding: 0;
`

export const HalfPageDesktop = styled.div`
  ${fromMd} {
    width: 50%;
  }
  display: flex;
  align-items: center;
  flex: 1;
`
